import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Pasé de no llegar a fin de mes a generar ingresos extra en 30 días, sin cambiar mi trabajo. Solo cambié cómo reacciono al dinero.',
  author: 'Marcela V.',
  location: 'Colombia',
  image: 'https://cdn.magicpatterns.com/uploads/jpo5WAfkDEwHG2t1rwtVmS/www.thispersondoesnotexist.jpg'
}, {
  quote: 'Lo que más me sorprendió no fue el dinero… fue la paz mental que sentí por primera vez en años.',
  author: 'Carolina M.',
  location: 'España',
  image: 'https://cdn.magicpatterns.com/uploads/oKX2XtkMyJpBwYVxSTt4xm/www.thispersondoesnotexist.jpg'
}, {
  quote: 'Dejé de discutir con mi pareja por dinero en 2 semanas. Eso no tiene precio.',
  author: 'Lucía S.',
  location: 'México',
  image: 'https://cdn.magicpatterns.com/uploads/iwbXrh7DxJoE7dQ8uKAtDA/www.thispersondoesnotexist.jpg'
}, {
  quote: 'Soy contadora. Siempre fui escéptica con estos temas. Compré por curiosidad… y lo que cambió no fue ‘magia’, fue cómo empecé a tomar decisiones con el dinero. En 3 semanas eliminé una deuda que llevaba meses arrastrando.',
  author: 'Valeria R.',
  location: 'Argentina',
  image: 'https://cdn.magicpatterns.com/uploads/iWMUUKkq9KPTHfYFTHoEX8/www.thispersondoesnotexist.jpg'
}];
export function Testimonials() {
  return <section className="py-24 bg-[#F9F9F7]" data-id="element-303">
      <div className="max-w-6xl mx-auto px-6" data-id="element-304">
        {/* ROMPE-ESCEPTICISMO DIRECTO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto text-center mb-20" data-id="element-305">
          <p className="text-stone-600 text-lg leading-relaxed mb-4" data-id="element-306">
            Puede que una parte de ti esté dudando… y es normal. <br data-id="element-307" />
            Porque te enseñaron a confiar solo en lo externo… no en cómo operas
            por dentro.
          </p>
          <p className="text-stone-900 font-bold text-2xl font-serif italic" data-id="element-308">
            No necesitas creer en esto… solo necesitas probarlo.
          </p>
        </motion.div>

        <div className="text-center mb-16" data-id="element-309">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 py-2 px-4 rounded-full bg-white border border-[#C5A059]/30 shadow-sm mb-8" data-id="element-310">
            <Star className="w-4 h-4 fill-[#C5A059] text-[#C5A059]" data-id="element-311" />
            <span className="text-stone-800 text-sm font-semibold tracking-wide" data-id="element-312">
              4.9/5 Calificación
            </span>
            <span className="text-stone-400 text-sm" data-id="element-313">| +4,500 mujeres</span>
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-serif text-stone-900 mb-6" data-id="element-314">
            Historias de Transformación
          </h2>
          <div className="w-12 h-[1px] bg-[#C5A059] mx-auto" data-id="element-315"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-12" data-id="element-316">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative flex flex-col" data-id="element-317">
              <Quote className="w-8 h-8 text-[#C5A059] opacity-20 mb-4" data-id="element-318" />
              <p className="text-stone-700 text-xl font-serif italic mb-8 leading-relaxed flex-grow" data-id="element-319">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-stone-200/60" data-id="element-320">
                <img src={testimonial.image} alt={`Fotografía de ${testimonial.author}`} className="w-12 h-12 rounded-full object-cover border border-stone-200/60 shadow-sm" data-id="element-321" />
                <div data-id="element-322">
                  <p className="font-semibold text-stone-900 tracking-wide" data-id="element-323">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-stone-500 uppercase tracking-widest mt-1" data-id="element-324">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16 text-center" data-id="element-325">
          <p className="text-xs md:text-sm text-stone-400 italic max-w-2xl mx-auto" data-id="element-326">
            * Estos resultados son el reflejo del compromiso de cada mujer con
            su propia reprogramación. Los cambios internos preceden siempre a
            los cambios externos.
          </p>
        </motion.div>
      </div>
    </section>;
}